import { ProtectedResourceScopes } from '@azure/msal-angular';
import { BrowserCacheLocation, InteractionType, LogLevel } from '@azure/msal-browser';
import { Settings } from '../app/app.settings';
import { loggerCallback } from './common';

export const prodSettings: Settings = {
  baseUrl: 'https://ch-insecta-api.se.research.corteva.com',
  environment: 'prod',
  isProd: true,
  appInsightsConnectionString:
    'InstrumentationKey=fee37db9-9737-4692-86d0-7a94b439b31f;IngestionEndpoint=https://eastus2-3.in.applicationinsights.azure.com/;LiveEndpoint=https://eastus2.livediagnostics.monitor.azure.com/;ApplicationId=1585158b-7347-4a81-8c8a-d2f14ed6d954',
  msal: {
    config: {
      auth: {
        clientId: '913ed134-1629-43a8-adb2-c758fef26c5d',
        authority: 'https://login.microsoftonline.com/3e20ecb2-9cb0-4df1-ad7b-914e31dcdda4/',
        redirectUri: 'https://ch-insecta.se.research.corteva.com/after-login',
        postLogoutRedirectUri: 'https://ch-insecta.se.research.corteva.com/after-logout',
        navigateToLoginRequestUrl: true
      },
      cache: {
        cacheLocation: BrowserCacheLocation.LocalStorage
      },
      system: {
        loggerOptions: {
          loggerCallback,
          logLevel: LogLevel.Warning,
          piiLoggingEnabled: false
        }
      }
    },
    guard: {
      interactionType: InteractionType.Redirect
    },
    interceptor: {
      interactionType: InteractionType.Redirect,
      protectedResourceMap: new Map<string, Array<string | ProtectedResourceScopes> | null>([
        ['https://ch-insecta-api.se.research.corteva.com', ['api://913ed134-1629-43a8-adb2-c758fef26c5d/API.Call']]
      ])
    }
  }
};
